import React from "react";

/**
 * Pagination bar: Previous / Next + size selector 25/50/100
 * Props: total, skip, limit, onSkipChange, onLimitChange
 */
export default function PaginationBar({ total, skip, limit, onSkipChange, onLimitChange }) {
  const from = total === 0 ? 0 : skip + 1;
  const to = Math.min(skip + limit, total);
  const canPrev = skip > 0;
  const canNext = skip + limit < total;

  return (
    <div className="flex items-center justify-between px-2 py-3 text-xs text-slate-600">
      <div className="flex items-center gap-2">
        <span>Mostrando</span>
        <select
          className="select !w-20 !py-1 !px-2"
          value={limit}
          onChange={(e) => {
            onLimitChange(+e.target.value);
            onSkipChange(0);
          }}
          data-testid="pagination-size"
        >
          {[25, 50, 100].map((n) => <option key={n} value={n}>{n}</option>)}
        </select>
        <span>por página</span>
      </div>
      <div className="flex items-center gap-3">
        <span>
          {from}–{to} de <span className="font-semibold text-slate-800">{total}</span>
        </span>
        <button
          className="btn btn-ghost !py-1 !px-2 !text-xs"
          disabled={!canPrev}
          onClick={() => onSkipChange(Math.max(0, skip - limit))}
          data-testid="pagination-prev"
        >
          ← Anterior
        </button>
        <button
          className="btn btn-ghost !py-1 !px-2 !text-xs"
          disabled={!canNext}
          onClick={() => onSkipChange(skip + limit)}
          data-testid="pagination-next"
        >
          Siguiente →
        </button>
      </div>
    </div>
  );
}
